module.exports = __webpack_public_path__ + "static/img/zxtp.62849ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zxtp.png
// module id = 8h00
// module chunks = 0